<template>
  <div class="product-header">
      <div class="header-content">
         
          <div class="content-right">
              <router-view></router-view>
          </div>
      </div>
  </div>
  </template>
<script>
    export default {
        data(){
            return{
            openeds:['1']
            }
        }
    }
</script>


<style lang="scss">
    .jaoyu{
        padding-top: 20px;
    }
.product-header .header-content .content-left .el-menu ul li {
    padding-top: 0px !important;
}
    .el-submenu__title:focus, .el-submenu__title:hover {
    outline: 0;
    background-color: #fff;
}
.el-submenu .el-menu-item {
    height: 30px;
    line-height: 30px;
    padding: 0 45px;
    min-width: 100px;
}
.el-submenu__title i {
    color: #909399;
    font-size: 16px;
}
.prs .el-submenu .el-menu-item {
    height: 30px;
    line-height: 30px;
    min-width: 100px;
    margin-left: -25px !important;
}
.prs .el-submenu__title {
    margin-left: -22px !important;
    padding-top: 10px;
    font-size: 16px;
    color: #303133;
    padding: 0 20px;
    cursor: pointer;
    box-sizing: border-box;
}
 .active{
        color: #0E67DF !important;
       
    }
    .product-header{
        width: 100%;
    }
</style>